export const enUSOnboarding = {
  // Progress
  stepOf: 'Step {{current}} of {{total}}',

  // Step 1: Welcome
  welcomeTitle: 'Welcome to Nomi!',
  welcomeMessage: 'Let\'s set up your finances in a few quick steps. You\'ll create a payment account, pick your spending categories, and optionally add your first recurring bill.',
  welcomeStart: 'Get Started',
  welcomeSkip: 'Skip setup',

  // Step 2: Account
  accountTitle: 'Create your first account',
  accountMessage: 'Where does your money come from? Add a bank account or credit card.',
  accountNameLabel: 'Account name',
  accountNamePlaceholder: 'e.g., Chase Checking',
  accountTypeLabel: 'Account type',
  accountTypeCreditCard: 'Credit Card',
  accountTypeBankAccount: 'Bank Account',
  accountTypeDebitCard: 'Debit Card',
  accountTypeCash: 'Cash',
  accountCreate: 'Create Account',
  accountCreating: 'Creating...',
  accountSkip: 'Skip',
  accountError: 'Failed to create account. Please try again.',
  accountValidationName: 'Account name is required',

  // Step 3: Categories
  categoriesTitle: 'Choose your categories',
  categoriesMessage: 'Select the spending categories that fit your household. You can always add more later.',
  categoriesCreate: 'Create Categories',
  categoriesCreating: 'Creating...',
  categoriesSkip: 'Skip',
  categoriesError: 'Failed to create some categories. Please try again.',
  categoriesNoneSelected: 'Select at least one category',
  // Preset category names
  categoryHousing: 'Housing',
  categoryFood: 'Food',
  categoryTransport: 'Transport',
  categoryLeisure: 'Leisure',
  categoryHealth: 'Health',
  categoryEducation: 'Education',
  categoryClothing: 'Clothing',
  categorySubscriptions: 'Subscriptions',

  // Step 4: Bill (optional)
  billTitle: 'Add your first bill',
  billMessage: 'Set up a recurring bill so Nomi can track it for you every month. This step is optional.',
  billDescriptionLabel: 'Description',
  billDescriptionPlaceholder: 'e.g., Rent, Netflix, Internet',
  billAmountLabel: 'Amount',
  billStartDateLabel: 'Start date',
  billCategoryLabel: 'Category',
  billSelectCategory: 'Select a category',
  billAccountLabel: 'Paying account',
  billSelectAccount: 'Select an account',
  billCreate: 'Create Bill',
  billCreating: 'Creating...',
  billSkip: 'Skip',
  billError: 'Failed to create bill. Please try again.',
  billValidationDescription: 'Description is required',
  billValidationAmount: 'Amount is required',
  billValidationStartDate: 'Start date is required',

  // Step 5: Done
  doneTitle: 'You\'re all set!',
  doneMessage: 'Your finances are ready to go. Check your dashboard to see everything in action.',
  doneSummaryAccounts: '{{total}} account created',
  doneSummaryCategories: '{{total}} categories created',
  doneSummaryBills: '{{total}} bill created',
  doneFinish: 'Go to Dashboard',
} as const;
